import { render, staticRenderFns } from "./AutomationCSVMapping.vue?vue&type=template&id=2f8fe48d&scoped=true&"
import script from "./AutomationCSVMapping.vue?vue&type=script&lang=js&"
export * from "./AutomationCSVMapping.vue?vue&type=script&lang=js&"
import style0 from "./AutomationCSVMapping.vue?vue&type=style&index=0&id=2f8fe48d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8fe48d",
  null
  
)

export default component.exports